import { createSelector } from 'reselect';
import { getAppState } from './appStateSelectors';
import {
  getCurrentSegmentName,
  getPreviousSegmentNames,
} from './segmentConfigSelectors';

export const getSegmentState = state => state.segmentState;

export const getCurrentSegmentState = createSelector(
  getSegmentState,
  getCurrentSegmentName,
  (segmentState, currentSegmentName) => segmentState[currentSegmentName]
);

export const getCurrentSegmentFormValues = createSelector(
  getAppState,
  getCurrentSegmentState,
  (appState, currentSegmentState = {}) => ({
    ...currentSegmentState,
    config: {
      ...(currentSegmentState.config || {}),
      ...appState,
    },
  })
);

export const getPreviousSegmentState = createSelector(
  getSegmentState,
  getPreviousSegmentNames,
  (segmentState, previousSegmentNames) => {
    const result = previousSegmentNames.reduce((state, name) => {
      state[name] = segmentState[name];
      return state;
    }, {});

    return result;
  }
);
